<main class="h-dvh overflow-hidden">
  <router-outlet></router-outlet>
</main>

<p-toast key="pwa-update" position="top-center" (onClose)="pwaUpdate.applyUpdate()">
  <ng-template #message let-message>
    <div class="flex items-center gap-3 w-full cursor-pointer" (click)="pwaUpdate.applyUpdate()">
      <i class="pi pi-refresh text-xl"></i>
      <div>
        <div class="font-semibold">{{ message.summary }}</div>
        <div class="text-sm mt-1">{{ message.detail }}</div>
      </div>
    </div>
  </ng-template>
</p-toast>
